import { useCallback, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux"
import { generateChart } from "../helpers/generateChart";
import { ReturnMapTreeNode, ReturnsMapStore } from "../model/redux-model"

interface ChartSize {
	width: number;
	height: number;
	hasSize: boolean;
}

export const MapComponent = () => {
	const rootNode = useSelector<ReturnsMapStore, ReturnMapTreeNode | null>(x => x.tree.root);
	const chartContainerRef = useRef<HTMLDivElement>(null);
	const [chartSize, setChartSize] = useState<ChartSize>({ width: 0, height: 0, hasSize: false });

	useEffect(() => {
		if (chartContainerRef.current === null)
			return;

		setChartSize({ width: chartContainerRef.current.offsetWidth, height: chartContainerRef.current.offsetHeight, hasSize: true });

		if (ResizeObserver)
		{
			var resizeObserver = new ResizeObserver(() => {
				if (chartContainerRef.current == null)
					return;

					setChartSize({ width: chartContainerRef.current.offsetWidth, height: chartContainerRef.current.offsetHeight, hasSize: true });
			});

			resizeObserver.observe(chartContainerRef.current);

			return () => {
				resizeObserver.disconnect();
			}
		}
	}, [chartContainerRef.current]);

	useEffect(() => {
		if (rootNode === null)
			return;
		if (!chartSize.hasSize)
			return;
		if (chartContainerRef.current === null)
			return;

		const newSvg = generateChart({ root: rootNode, width: chartSize.width, height: chartSize.height });

		chartContainerRef.current.innerHTML = '';
		chartContainerRef.current.append(newSvg);
	}, [rootNode, chartSize, chartContainerRef.current]);

	return <div className="map-widget" ref={chartContainerRef}></div>;
}
